// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kFaa","header":"njNdH","content":"ZvzgE","controls":"U1pmg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/empty-states/empty-states.scss
// module id = 1397
// module chunks = 0